import { atom } from 'recoil';

export const refreshCoverablesOnsaSelectorAtom = atom<object>({
    key: 'refreshCoverablesOnsaSelectorAtom',
    default: {}
});
